// extracted by mini-css-extract-plugin
export default {"box":"OtPP0Bi0uM3HzAsEJ7jb","clientFee":"QBxqMgg1GNbVRKO64L_w","description":"U6TPzg1BHLOfmCPrIWgS","extraInfoRow":"ZIuTBYMojjS3G5k3_I1g","totalRow":"POZ36FPvtf4OuJSSOdLW"};